module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gk_szls.8a34832b.png";